import { SpsIcon, TagKind } from "@spscommerce/ds-shared";
import * as React from "react";

import { SpsCard, SpsTag } from "../index";

export const SpsTagPropTypes = SpsTag['propTypes'];
export class SpsTagBasic1 extends React.Component<{"data-testid": any}> {
    // Used in react-live examples
    static reactLive = {
        code: `
        <SpsCard>
            <div className="row">
                <div className="mr-1 mb-1">
                    <SpsTag kind="default">
                    <span>Default</span>
                    </SpsTag>
                </div>
                <div className="mr-1 mb-1">
                    <SpsTag kind="key">
                    <span>Key</span>
                    </SpsTag>
                </div>
                <div className="mr-1 mb-1">
                    <SpsTag kind="warning">
                    <span>Warning</span>
                    </SpsTag>
                </div>
                <div className="mr-1 mb-1">
                    <SpsTag kind="error">
                    <span>Error</span>
                    </SpsTag>
                </div>
                <div className="mr-1 mb-1">
                    <SpsTag kind="pending">
                    <span>Pending</span>
                    </SpsTag>
                </div>
                <div className="mr-1 mb-1">
                    <SpsTag kind="success">
                    <span>Success</span>
                    </SpsTag>
                </div>
                <div className="mr-1 mb-1">
                    <SpsTag kind="info">
                    <span>Info</span>
                    </SpsTag>
                </div>
            </div>
        </SpsCard>
        `
    };
    render() {
        const { "data-testid": testId } = this.props;
        // Used in react-testing-library specs
        return (
            <>
              <SpsCard>
                    <div className="row">
                        <div className="mr-1 mb-1">
                            <SpsTag kind={TagKind.DEFAULT} data-testid={`${testId}__kind--default`}>
                                <span>Default</span>
                            </SpsTag>
                        </div>
                        <div className="mr-1 mb-1">
                            <SpsTag kind={TagKind.KEY} data-testid={`${testId}__kind--key`}>
                                <span>Key</span>
                            </SpsTag>
                        </div>
                        <div className="mr-1 mb-1">
                            <SpsTag kind={TagKind.WARNING} data-testid={`${testId}__kind--warning`}>
                                <span>Warning</span>
                            </SpsTag>
                        </div>
                        <div className="mr-1 mb-1">
                            <SpsTag kind={TagKind.ERROR} data-testid={`${testId}__kind--error`}>
                                <span>Error</span>
                            </SpsTag>
                        </div>
                        <div className="mr-1 mb-1">
                            <SpsTag kind={TagKind.PENDING} data-testid={`${testId}__kind--pending`}>
                                <span>Pending</span>
                            </SpsTag>
                        </div>
                        <div className="mr-1 mb-1">
                            <SpsTag kind={TagKind.SUCCESS} data-testid={`${testId}__kind--success`}>
                                <span>Success</span>
                            </SpsTag>
                        </div>
                        <div className="mr-1 mb-1">
                            <SpsTag kind={TagKind.INFO} data-testid={`${testId}__kind--info`}>
                                <span>Info</span>
                            </SpsTag>
                        </div>
                    </div>
                </SpsCard>
            </>
        );
    }
}

export class SpsTagWithIcon1 extends React.Component<{"data-testid": any}>  {
    static reactLive = {
        code: `
    <SpsCard>
        <div className="row">
            <div className="mr-1 mb-1">
                <SpsTag kind="default" icon="sps-icon-info-circle">
                    <span>Default</span>
                </SpsTag>
            </div>
            <div className="mr-1 mb-1">
                <SpsTag kind="key" icon="sps-icon-checkmark">
                    <span>Key</span>
                </SpsTag>
            </div>
            <div className="mr-1 mb-1">
                <SpsTag kind="warning" icon="sps-icon-exclamation-triangle">
                    <span>Warning</span>
                </SpsTag>
            </div>
            <div className="mr-1 mb-1">
                <SpsTag kind="error" icon="sps-icon-exclamation-circle">
                    <span>Error</span>
                </SpsTag>
            </div>
            <div className="mr-1 mb-1">
                <SpsTag kind="pending" icon="sps-icon-ellipses">
                    <span>Pending</span>
                </SpsTag>
            </div>
            <div className="mr-1 mb-1">
                <SpsTag kind="success" icon="sps-icon-checkmark">
                    <span>Success</span>
                </SpsTag>
            </div>
            <div className="mr-1 mb-1">
                <SpsTag kind="info" icon="sps-icon-info-circle">
                    <span>Info</span>
                </SpsTag>
            </div>
        </div>
    </SpsCard>
        `
    }
    render() {
        const { "data-testid": testId } = this.props;
        return (
            <SpsCard>
                <div className="row">
                    <div className="mr-1 mb-1">
                        <SpsTag kind={TagKind.DEFAULT} icon={SpsIcon.INFO_CIRCLE} data-testid={`${testId}__kind--default`}>
                            <span>Default</span>
                        </SpsTag>
                    </div>
                    <div className="mr-1 mb-1">
                        <SpsTag kind={TagKind.KEY} icon={SpsIcon.CHECKMARK} data-testid={`${testId}__kind--key`}>
                            <span>Key</span>
                        </SpsTag>
                    </div>
                    <div className="mr-1 mb-1">
                        <SpsTag kind={TagKind.WARNING} icon={SpsIcon.EXCLAMATION_TRIANGLE} data-testid={`${testId}__kind--warning`}>
                            <span>Warning</span>
                        </SpsTag>
                    </div>
                    <div className="mr-1 mb-1">
                        <SpsTag kind={TagKind.ERROR} icon={SpsIcon.EXCLAMATION_CIRCLE} data-testid={`${testId}__kind--error`}>
                            <span>Error</span>
                        </SpsTag>
                    </div>
                    <div className="mr-1 mb-1">
                        <SpsTag kind={TagKind.PENDING} icon={SpsIcon.ELLIPSES} data-testid={`${testId}__kind--pending`}>
                            <span>Pending</span>
                        </SpsTag>
                    </div>
                    <div className="mr-1 mb-1">
                        <SpsTag kind={TagKind.SUCCESS} icon={SpsIcon.CHECKMARK} data-testid={`${testId}__kind--success`}>
                            <span>Success</span>
                        </SpsTag>
                    </div>
                    <div className="mr-1 mb-1">
                        <SpsTag kind={TagKind.INFO} icon={SpsIcon.INFO_CIRCLE} data-testid={`${testId}__kind--info`}>
                            <span>Info</span>
                        </SpsTag>
                    </div>
                </div>
            </SpsCard>
        );
    }
}